import React from "react";
import Navbar from "../DashBoardComponents/Navbar";
import Footer from "../../src/DoxzonNew/Footer";
import PrivacyPolicyContent from "./PolicyContents/PrivacyPolicyContent";
function PrivacyPolicy() {


  return (
    <>
      <Navbar />
      <PrivacyPolicyContent />
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
